__turbopack_context__.v({
  "grid": "ProductGrid-module-scss-module__aY221G__grid",
  "grid__cell": "ProductGrid-module-scss-module__aY221G__grid__cell",
  "grid__empty": "ProductGrid-module-scss-module__aY221G__grid__empty",
});
